// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__Jl0jU","animate-profit":"styles_animate-profit__XYeh_","skeleton-animation":"styles_skeleton-animation__3KvHb"};